import { render, staticRenderFns } from "./PriceOtherExchange.vue?vue&type=template&id=96df198a&scoped=true"
import script from "./PriceOtherExchange.vue?vue&type=script&lang=js"
export * from "./PriceOtherExchange.vue?vue&type=script&lang=js"
import style0 from "./PriceOtherExchange.vue?vue&type=style&index=0&id=96df198a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96df198a",
  null
  
)

export default component.exports